module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921002649_T.7cc0841c.jpg";